import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import * as api from "../constant/NewAPI";

const AuthManager = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  // Define routes where auth check should NOT run
  const publicPaths = [
    "/auth/tenvic-login",
    "/auth/tenvic-student",
    "/auth/tenvic-institution",
    "/auth/forgot-password",
  ];

  const isPublicPath = publicPaths.includes(currentPath);

  const roleId = localStorage.getItem("RoleId");
  let roleType = "/auth/tenvic-login";
  if (roleId === "8") roleType = "/auth/tenvic-student";
  else if (roleId === "7") roleType = "/auth/tenvic-institution";

  // Parse and sanitize config values
  const accessTime = parseInt(localStorage.getItem("accessConfigValue") || "60", 10);
  const logoutTimeSeconds = parseInt(localStorage.getItem("closeConfigValue") || "60", 10);
  const refreshTimeSeconds = parseInt(localStorage.getItem("refreshConfigValue") || "60", 10);

  const logoutTime = logoutTimeSeconds * 1000;
  const refreshInterval = refreshTimeSeconds * 1000;

  const activityTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const refreshTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isUserActiveRef = useRef<boolean>(true); // start as active

  const refreshToken = async () => {
    try {
      const response = await axios.post(
        api.refreshToken,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      if (response.data?.data) {
        localStorage.setItem("accessToken", response.data.data);
      } else {
        logoutUser();
      }
    } catch (error) {
      console.error("Token refresh failed:", error);
      logoutUser();
    }
  };

  const logoutUser = () => {
    localStorage.clear();
    window.location.href = roleType;
  };

  const resetActivityTimer = () => {
    isUserActiveRef.current = true;

    if (activityTimeoutRef.current) {
      clearTimeout(activityTimeoutRef.current);
    }

    activityTimeoutRef.current = setTimeout(() => {
      isUserActiveRef.current = false;
      logoutUser();
    }, logoutTime);
  };

  useEffect(() => {
    if (isPublicPath) return; // Skip everything on public routes

    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      window.location.href = roleType;
      return;
    }

    // Start refresh token loop
    const startRefreshCycle = () => {
      if (isUserActiveRef.current) {
        refreshToken();
        refreshTimeoutRef.current = setTimeout(startRefreshCycle, refreshInterval);
      }
    };

    refreshTimeoutRef.current = setTimeout(startRefreshCycle, refreshInterval);

    // Start auto logout timer
    activityTimeoutRef.current = setTimeout(() => {
      isUserActiveRef.current = false;
      logoutUser();
    }, logoutTime);

    // Listen for user activity
    window.addEventListener("click", resetActivityTimer);
    window.addEventListener("mousemove", resetActivityTimer);
    window.addEventListener("keypress", resetActivityTimer);

    return () => {
      if (activityTimeoutRef.current) clearTimeout(activityTimeoutRef.current);
      if (refreshTimeoutRef.current) clearTimeout(refreshTimeoutRef.current);

      window.removeEventListener("click", resetActivityTimer);
      window.removeEventListener("mousemove", resetActivityTimer);
      window.removeEventListener("keypress", resetActivityTimer);
    };
  }, [currentPath]);

  return null;
};

export default AuthManager;
